'use client';
import { ComponentProps } from 'react';
import { Layout } from '@/shared/ui/layout';

type Props = ComponentProps<typeof Layout>;
export const ProductCardBottomOverlayWrapper = ({ media, ...props }: Props) => {
    return (
        <Layout
            className="product-card__bottom-overlay"
            data-testid="product-card-bottom-overlay-wrapper"
            media={{
                initial: {},
                ...media,
            }}
            {...props}
        />
    );
};
